// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgot-password {
  display: block;
  margin: 0.25rem 0.125rem;
  text-align: right;
  font-size: 0.875rem;
}

.address {
  color: #fff;
}
.address p {
  margin: 0;
}

.terms {
  margin: 1rem 0 0.125rem;
}
.terms p {
  display: inline-block;
  margin: 0 1rem;
}

a {
  color: #343a40;
}`, "",{"version":3,"sources":["webpack://./src/app/auth/login/login.component.scss","webpack://./src/assets/styles/variables.scss"],"names":[],"mappings":"AAGA;EACE,cAAA;EACA,wBAAA;EACA,iBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,WAAA;AAFF;AAIE;EACE,SAAA;AAFJ;;AAMA;EACE,uBAAA;AAHF;AAKE;EACE,qBAAA;EACA,cAAA;AAHJ;;AAOA;EACE,cCRS;ADIX","sourcesContent":["@import 'variables';\n@import 'functions';\n\n.forgot-password {\n  display: block;\n  margin: rem(4) rem(2);\n  text-align: right;\n  font-size: rem(14);\n}\n\n.address {\n  color: $white;\n\n  p {\n    margin: 0;\n  }\n}\n\n.terms {\n  margin: rem(16) 0 rem(2);\n\n  p {\n    display: inline-block;\n    margin: 0 1rem;\n  }\n}\n\na {\n  color: $gray-800;\n}\n","@import './functions.scss';\n\n$standard-blue: #54b0cb;\n$dark-blue: #456c9b;\n$green: #6fa163;\n$yellow: #f6af0b;\n$red: #e84e25;\n$min-contrast-ratio: 3;\n\n$enable-validation-icons: false;\n\n$white: #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-550: #8d959d;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black: #000 !default;\n\n$bg-color: #778899;\n$primary: $dark-blue;\n$secondary: $standard-blue;\n$body-color: $gray-600;\n$light: $gray-300;\n$text-muted: $gray-550;\n\n$h1-font-size: rem(28);\n$h2-font-size: rem(24);\n$h3-font-size: rem(19);\n\n$input-btn-padding-y: 0.1875rem;\n$input-btn-padding-x: 0.375rem;\n$input-color: $gray-600;\n$input-placeholder-color: $gray-500;\n\n$grid-gutter-width: 12px;\n$border-color: $gray-200;\n\n// table\n$table-cell-padding: 0.625rem;\n\n$banner-height: rem(60);\n\n@import '../../../node_modules/bootstrap/scss/_functions';\n@import '../../../node_modules/bootstrap/scss/_variables';\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
